import { createReducer, on } from '@ngrx/store';
import { TrackerDetailActions } from '../actions';
import {
  TrackerDetailAnalyticsQuery,
  TrackerDetailTodayQuery,
  TrackerQueryCollectionItem
} from '../states/tracker-detail.state.interface';
import { trackerState } from '../tracker.state';

// Detail action handlers - these return `on` functions that can be used in createReducer
export const trackerDetailHandlers: Array<
  Parameters<typeof createReducer<typeof trackerState>>[1]
> = [
  on(TrackerDetailActions.fetchQueriesCollection, (state, payload) => {
    const existingQueryIndex = state.detail.queriesCollection.findIndex(
      (query) => query.type === payload.queryType
    );
    if (existingQueryIndex === -1) {
      let newQuery: TrackerQueryCollectionItem | undefined = undefined;
      const isTodayQuery = payload.queryType.endsWith('-today');
      const isAnalyticsQuery = payload.queryType.includes('-analytics-');

      if (isTodayQuery) {
        newQuery = {
          type: payload.queryType,
          data: {
            scores: []
          },
          loading: true,
          error: undefined,
          fetchCount: 1
        } as TrackerDetailTodayQuery;
      } else if (isAnalyticsQuery) {
        newQuery = {
          type: payload.queryType,
          data: {
            metricTimeline: [],
            metricDetailScore: [],
            predictiveData: {
              predictiveInsight: '',
              predictiveLevel: ''
            }
          },
          loading: true,
          error: undefined,
          fetchCount: 1
        } as TrackerDetailAnalyticsQuery;
      } else {
        return state;
      }
      return {
        ...state,
        detail: {
          ...state.detail,
          queriesCollection: [...state.detail.queriesCollection, newQuery]
        }
      };
    }
    const newQueries = [...state.detail.queriesCollection];
    newQueries[existingQueryIndex] = {
      ...newQueries[existingQueryIndex],
      loading: true,
      error: undefined,
      fetchCount: newQueries[existingQueryIndex].fetchCount + 1
    };

    return {
      ...state,
      detail: {
        ...state.detail,
        queriesCollection: newQueries
      }
    };
  }),
  on(TrackerDetailActions.fetchQueriesCollectionFailed, (state, payload) => {
    const existingQueryIndex = state.detail.queriesCollection.findIndex(
      (query) => query.type === payload.queryType
    );
    if (existingQueryIndex === -1) {
      return state;
    }
    const newQueries = [...state.detail.queriesCollection];

    newQueries[existingQueryIndex] = {
      ...newQueries[existingQueryIndex],
      loading: false,
      error: payload.error
    };

    return {
      ...state,
      detail: {
        ...state.detail,
        queriesCollection: newQueries
      }
    };
  }),
  on(TrackerDetailActions.fetchDetailTodaySuccess, (state, payload) => {
    const existingQueryIndex = state.detail.queriesCollection.findIndex(
      (query) => query.type === payload.queryType
    );
    if (existingQueryIndex !== -1) {
      const newQueries = [...state.detail.queriesCollection];
      newQueries[existingQueryIndex] = {
        ...newQueries[existingQueryIndex],
        loading: false,
        error: undefined,
        data: payload.data
      } as TrackerDetailTodayQuery;

      return {
        ...state,
        detail: {
          ...state.detail,
          queriesCollection: newQueries
        }
      };
    }
    return state;
  }),
  on(TrackerDetailActions.fetchDetailAnalyticsSuccess, (state, payload) => {
    const existingQueryIndex = state.detail.queriesCollection.findIndex(
      (query) => query.type === payload.queryType
    );
    if (existingQueryIndex !== -1) {
      const newQueries = [...state.detail.queriesCollection];
      newQueries[existingQueryIndex] = {
        ...newQueries[existingQueryIndex],
        loading: false,
        error: undefined,
        data: payload.data
      } as TrackerDetailAnalyticsQuery;

      return {
        ...state,
        detail: {
          ...state.detail,
          queriesCollection: newQueries
        }
      };
    }
    return state;
  })
];
